// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["__sentryRewritesTunnelPath__"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"0dogutgGiYyjklF9THm8x"};globalThis["__sentryBasePath"] = undefined;globalThis["__rewriteFramesAssetPrefixPath__"] = "";import * as Sentry from '@sentry/nextjs'

const defaultTracesSampleRate = 0.1
const resolvedTracesSampleRate = Number(
  process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ??
    defaultTracesSampleRate.toString(),
)
const tracesSampleRate = Number.isFinite(resolvedTracesSampleRate)
  ? resolvedTracesSampleRate
  : defaultTracesSampleRate

const replaySessionSampleRate = 0.1
const replayOnErrorSampleRate = 1.0

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate,

  replaysSessionSampleRate: replaySessionSampleRate,
  replaysOnErrorSampleRate: replayOnErrorSampleRate,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})

let replayIntegrationPromise: Promise<void> | null = null

const loadReplayIntegration = () => {
  if (!replayIntegrationPromise) {
    replayIntegrationPromise = Sentry.lazyLoadIntegration('replayIntegration')
      .then((createReplayIntegration) => {
        Sentry.addIntegration(createReplayIntegration())
      })
      .catch(() => undefined)
  }

  return replayIntegrationPromise
}

if (replaySessionSampleRate > 0 && Math.random() < replaySessionSampleRate) {
  void loadReplayIntegration()
}

if (replayOnErrorSampleRate > 0 && typeof window !== 'undefined') {
  const loadReplayOnError = () => {
    window.removeEventListener('error', loadReplayOnError)
    window.removeEventListener('unhandledrejection', loadReplayOnError)

    if (Math.random() <= replayOnErrorSampleRate) {
      void loadReplayIntegration()
    }
  }

  window.addEventListener('error', loadReplayOnError)
  window.addEventListener('unhandledrejection', loadReplayOnError)
}
